import{useContext}from"react";import{RadioGroupContext}from"../RadioGroup";export var useRadioGroup=function(){return useContext(RadioGroupContext)};